module.exports = __webpack_public_path__ + "img/total.f79e339.jpg";